export function validateEmail(mail: string | undefined) {
  return mail !== undefined && (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail));
}